import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
  de: {
    'app.install.title': 'App installieren',
    'app.updateAvailable': 'Eine neue Version ist verfügbar und wird in {timer} Sekunden automatisch geladen.',
    'app.update.title': 'Update verfügbar',
  },
  en: {
    'app.install.title': 'Install app',
    'app.updateAvailable': 'A new version is available and will be loaded automatically in {timer} seconds.',
    'app.update.title': 'Update available',
  },
};

const i18n = new VueI18n({
  locale: 'de',
  messages,
  silentTranslationWarn: true,
});

export default i18n;
